import { store } from "@/shared-store";
import { Store } from "vuex";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";
import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";

export const trackMarketingEvent = (
  eventName: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventContext: Record<string, any> = {},
  eventId: string | null = null
): Promise<AxiosResponse> => {
  const vuexStore = store as unknown as Store<IVuexState>;
  const cartTag = eventContext.cartTag ?? vuexStore.state.carts?.cartTag;

  eventContext.cartTag = cartTag;
  eventContext.userId = vuexStore.state.carts?.userId;

  return jwtApiClient.post(M3_API().CREATE_MARKETING_EVENT, {
    eventName: eventName,
    eventContext: eventContext,
    eventId: eventId,
  });
};
